import Vue from 'vue'
import {
  CONTACTS_SET,
} from '../mutations-types'

const state = {
  contacts: null
}

const getters = {
  contacts: state => state.contacts
}

const mutations = {
  [CONTACTS_SET] (state, data) {
    Vue.set(state, 'contacts', data)
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
